<div class="container-fluid py-3">
  <div class="row">
    <div class="col-12 px-0 pb-2">
      <h3
        style=" font-weight: 700;font-size: 18px;margin-bottom: 1.5rem;display: flex; align-items: center;color: #313A44;">
        Office Details
      </h3>

      <form [formGroup]="managerProfile" class="px-0" name="manager_Profile">
    <div class="row">
      <!-- Filed Starts -->
      <div class="form-group col-12 col-xl-9 mb-3">
        <div class="custom-form flex-grow-1 me-md-3">
          <input class="input_field px-3 pt-3" formControlName="manager_name" required trim maxlength="50"
            (keypress)="mainService.handleInputSpace($event)" />
          <label for="text" class="label-name">
            <span class="content-name f-c-p-3">
              Manager Name
            </span>
          </label>
        </div>
      </div>
    </div>
    <!-- Field Ends -->
    <div class="row">

      <!-- Filed Starts -->
      <div class="form-group col-12 col-xl-9 mb-3">
        <div class="custom-form flex-grow-1 me-md-3">
          <input class="input_field px-3 pt-3" formControlName="manager_email" required trim
            (keypress)="mainService.handleInputSpace($event)" />
          <label for="text" class="label-name">
            <span class="content-name f-c-p-3">Manager Email Address</span>
          </label>
        </div>
      </div>
    </div>

    <div class="row">
      <!-- Filed Starts -->
      <div class="form-group col-12 col-xl-9 mb-3">
        <div class="custom-form flex-grow-1 me-md-3 position-relative">
          <span
            *ngIf="managerProfile.controls.manager_mobile &&  (managerProfile.controls.manager_mobile.value !== null && managerProfile.controls.manager_mobile.value !== '')"
            class="pt-2 pe-1 fw-bold dollar_input position-absolute" style="left: 14px; bottom: 8px;">+1</span>
          <input class="input_field pt-3"
            [ngStyle]="{'padding-left': managerProfile.value.manager_mobile !== '' ? '40px' : '1rem'}"
            name="manager_mobile" formControlName="manager_mobile" [mask]="mask" required />
          <label for="text" class="label-name">
            <span class="content-name f-c-p-3">
              Manager Phone Number
            </span>
          </label>
        </div>
      </div>
      <!-- Field Ends -->
    </div>
    <div class="row">
      <div class="col-12">
        <button type="button" button-primary-auth (click)="updateOfficeData()" class="me-3 px-4 py-3"
          [disabled]="!managerProfile.dirty" style="padding: 15px 45px !important">
          Save
        </button>
        
        <button button-login-secondary (click)="getValues()" style="padding: 15px 45px !important"
          *ngIf="managerProfile.dirty">
          Reset
        </button>
      </div>
    </div>
  </form>
    </div>
  </div>

  
</div>